module.exports = __webpack_public_path__ + "static/media/instructions_1.3f201188.svg";